<div mat-dialog-title>
    <ng-container *ngIf="!oldSamples">Ingresar número de muestras</ng-container> 
    <ng-container *ngIf="oldSamples">Se modificó correctamente la solicutd</ng-container>
    <div class="spacer"></div>

  </div>
  <mat-dialog-content>
      <!--.table-sm td, .table-sm th {
    padding: 0rem 0.6rem;
}-->  
          <form #myForm="ngForm">
           <table class="labels-input-table table  table-sm">
              <thead>
              <tr>
                <th scope="col">Etiqueta</th>
                <th scope="col">Contenedor</th>
                <th scope="col">Material</th>
                <th scope="col">Test</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let sample of samples" [class.old-sample-row]="!isNew(sample)" [hidden]="showSample(sample)">
                <td class="align-middle">
                    <mat-form-field class="example-full-width">
                        <input matInput #message minlength="12" maxlength="12" [(ngModel)]="sample.labelId"
                            [disabled]="sample.disabled == true" [customValidator]="myValidator"  #nameCtrl="ngModel" name="{{sample.containerId}}" required>
                        <mat-hint align="end">{{message.value.length}} / 12</mat-hint>
                        <mat-error *ngIf="nameCtrl.hasError('repeated')">
                          Número de muestra repetido.
                        </mat-error>
                        <mat-error *ngIf="nameCtrl.hasError('short')">
                          Debe contener 12 caracteres.
                        </mat-error>
                        <mat-error *ngIf="nameCtrl.hasError('duplicated')">
                          Número de muestra duplicado.
                        </mat-error>
                      </mat-form-field>
                </td>
                <td class="align-middle" [matTooltip]="sample?.containerDescription">{{ sample?.containerId }}</td>
                <td class="align-middle" [matTooltip]="sample?.specimenDescription">{{ sample?.specimenId }}</td>
                <td class="align-middle">
                    <mat-chip-list>
                        <mat-chip color="primary" *ngFor="let test of sample.tests"
                            [matTooltip]="test.description" [hidden]="test.toDelete">{{test.id}}</mat-chip>
                    </mat-chip-list>
                </td>
                <!--td class="align-middle"> <button mat-raised-button [class.new-sample]="isNew(sample)"><mat-icon (click)="printLabel(sample)">print</mat-icon></button></td-->

              </tr>
              </tbody>
            </table>
          </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close color ="warn">
        Cerrar
    </button>
    <button mat-raised-button (click)="saveSamples(myForm)" [disabled]="myForm.invalid" color="primary">
        <span> Enviar </span> 
    </button>
  </mat-dialog-actions>